window.addEventListener("load", function () {
document.querySelectorAll('.info_chiso .item').forEach(item => {
  const valueElement = item.querySelector('.value_progress');
  const bar = item.querySelector('.bar');

  if (valueElement && bar) {
    let value = parseFloat(valueElement.textContent.trim());

    // Giới hạn max 100
    if (value > 100) value = 100;

    bar.style.width = value + '%';
  }
});

});